module.exports = __webpack_public_path__ + "static/media/bulk-empty.3041b1ca.png";